import React from "react"
import axios from "axios";
import "./weather.scss"
export default class ActualWeather extends React.Component{
    
    state = {
        temperature: undefined,
        city: undefined,
        country: undefined,
        humidity: undefined,
        description: undefined,
        error: undefined,

    };        
    city = "Rouen";
    country = "France";
    API_KEY = "48af6c4597a6c8c38be734255ecf5b61";
    getWeather = async () => {
        //stops page refresh when Get Weather button is clicked
  

        //async await
        //const api_call = await fetch(`http://api.openweathermap.org/data/2.5/weather?q=${city},${country}&APPID=${API_KEY}&units=metric`);
        const api_call = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${this.city},${this.country}&APPID=${this.API_KEY}&units=imperial`
        );
        //converts api_call to readable format for program,
        //in this case its json
        const data = await api_call.json();
        //this prevents the user from hitting submit without
        //filling out the form
        //set values of state
        console.log(data)
        this.setState({
            //these values are found from calling the api_call
            //which is the data constant
            temperature: data.main.temp,
            city: data.name,
            country: data.sys.country,
            humidity: data.main.humidity,
            description: data.weather[0].description,
            error: ""
        });    

    };

    componentDidMount(){
        this.getWeather()
        setInterval(() => this.getWeather(), 600000)
        var url = `https://api.openweathermap.org/data/2.5/weather?q=${this.city},fr&appid=c21a75b667d6f7abb81f118dcf8d4611&units=metric `

        var callBackGetSuccess = function(data) {
            var element = document.getElementById("temperature");
            element.innerHTML = Math.round(data.main.temp) + "°C";
            // console.log(data.weather)
        }   
        axios.get(url, callBackGetSuccess).then(function(data) {
            //alert( "second success" );
            var element = document.getElementById("temperature");
            if(element === null) return
            element.innerHTML = Math.round(data.data.main.temp) + "°C";
        })
        .catch(function() {
            alert( "error" );
        })
        setInterval(function(data){
            var callBackGetSuccess = function(data) {
                var element = document.getElementById("temperature");
                if(element === null) return
                element.innerHTML = Math.round(data.main.temp) + "°C";
            }
            axios.get(url, callBackGetSuccess).then(function(data) {
                //alert( "second success" );
                var element = document.getElementById("temperature");
                if(element === null) return
                element.innerHTML = Math.round(data.data.main.temp) + "°C";
            })
            .catch(function() {
                alert( "error" );
            })
        }, 600000)
    }
    render(){
        switch (this.state.description){
            case "clear sky" :
                return (
                    <div className="icon sunny">
                        <div className="sun">
                            <div className="rays"></div>
                        </div>
                    </div>
                );
            case "few clouds" :
                return (
                    <div className="icon sun-shower">
                        <div className="cloud"></div>
                        <div className="sun">
                            <div className="rays"></div>
                        </div>
                    </div>
                );
            case "overcast clouds" :
                return (
                    <div className="icon cloudy">
                        <div className="cloud"></div>
                        <div className="cloud"></div>
                    </div>
                );
            case "broken clouds" :
                return (
                    <div className="icon cloudy">
                        <div className="cloud"></div>
                        <div className="cloud"></div>
                    </div>
                );
            case "scattered clouds" :
                return (
                    <div className="icon sun-shower">
                        <div className="cloud"></div>
                        <div className="sun">
                            <div className="rays"></div>
                        </div>
                    </div>
                );
            case "drizzle" :
                return (
                    <div className="icon rainy">
                        <div className="cloud"></div>
                        <div className="drizzle"></div>
                        
                    </div>
                );
            case "rain" :
                return (
                    <div className="icon sun-shower">
                        <div className="cloud"></div>
                        <div className="sun">
                            <div className="rays"></div>
                        </div>
                        <div className="rain"></div>
                    </div>
                );
            case "light rain" :
                return (
                    <div className="icon sun-shower">
                        <div className="cloud"></div>
                        <div className="sun">
                            <div className="rays"></div>
                        </div>
                        <div className="rain"></div>
                    </div>
                );
            case "shower rain" :
                return (
                    <div className="icon rainy">
                        
                        <div className="cloud cloudGrey"></div>
                        <div className="cloud"></div>
                        <div className="rain"></div>
                    </div>
                );
            case "moderate rain" :
                return (
                    <div className="icon rainy">
                        
                        <div className="cloud cloudGrey"></div>
                        <div className="cloud"></div>
                        <div className="rain"></div>
                    </div>
                );
            case "heavy intensity rain" :
                return (
                    <div className="icon rainy">
                        
                        <div className="cloud cloudGrey"></div>
                        <div className="cloud"></div>
                        <div className="rain"></div>
                    </div>
                );
            case "thunderstorm" :
                return (
                    <div className="icon thunder-storm">
                        <div className="cloud cloudGrey"></div>
                        <div className="lightning">
                            <div className="bolt"></div>
                            <div className="bolt"></div>
                        </div>
                    </div>
                );
            case "snow" :
                return (
                    <div className="icon flurries">
                        <div className="cloud cloudGrey"></div>
                        <div className="snow">
                            <div className="flake"></div>
                            <div className="flake"></div>
                        </div>
                    </div>
                );
            case "rain and snow" :
                return (
                    <div className="icon flurries">
                        <div className="cloud cloudGrey"></div>
                        <div className="snow">
                            <div className="flake"></div>
                            <div className="flake"></div>
                        </div>
                    </div>
                );
            case "mist" :
                return (
                    <div className="icon cloudy">
                        <div className="cloud"></div>
                        <div className="cloud"></div>
                    </div>
                );
            case "fog" :
                return (
                    <div className="icon cloudy">
                        <div className="cloud"></div>
                        <div className="cloud"></div>
                    </div>
                );
            default : return <div>pas dans la liste</div>
        }
    }
} 